<template>
  <div class="Subpage">
    <Bigmenu :NavStatus="Bignav" :Way="3" :ShowBackBtn="true" v-on:cellback="OpenStatus" style="z-index: 2"></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container v-if="!Bignav" :Type="false" :ImgUrl="'b01.png'" :Container="Container"  style="z-index: -6"></Container>
  </div>
</template>

<script>
import Bigmenu from '@/components/Bigmenu.vue'
import Back from '@/components/Back.vue';
import Container from '@/components/Container.vue';
export default {
  name: 'About',
  data () {
    return {

      Bignav: false,
      Container:{
        subtitle:'PBS (Pencil Beam Scanning) Technology ',
        videosrc:'P03.mp4',
        title:'筆尖射束技術介紹',
        list:[
          {
            body:"只有筆尖式射束掃描能投照真正的IMPT。不是所有的質子治療都能投照IMPT，只有" +
            "筆尖式射束掃描(Pencil Beam Scanning，PBS)可以IMPT能高度準確地瞄準腫瘤，所以" +
            "能聚焦成一道狹窄的質子射束，可以一點接著一點和一層接著一層地把腫瘤的所有部" +
            "分都「精確施予」放射劑量，甚至連形狀不規則的腫瘤也可以。對包覆著重要結構的" +
            "腫瘤(例如：大腦或脊髓)，或鄰近結構或器官的腫瘤(例如：經常會很接近膀胱或大腸" +
            "的攝護腺腫瘤，或鄰近心臟的乳房腫瘤)IMPT也都有效。"

          },

        ]
      }

    }
  },
  components: {
    Back,Container,Bigmenu
  },
  methods:{
    OpenStatus(v){
      this.Bignav = v.status
    }
  }
}
</script>
<style lang="scss" scoped>
  .Subpage{
    height: 100%;
    width: 100%;
  }
  .frame {

    position: absolute;
    background-image: url("../../assets/frame.png");
    background-position: center;
    height: 1080px;
    width: 1920px;
  }
</style>
